import React from 'react'
import './message.scss';
import Brand from '../brand/Brand';

type messageProps = {
    message: any,
    isHostDevice: boolean
};

const Message = ({message, isHostDevice}: messageProps) => {
    return (
        <div className="message">            
            { message.from !== 'user' && (
                <div className="message__brand">
                    <Brand size='small'/>
                </div>)
            }

            <div className={message.hasQr && !isHostDevice ? "message__container message__container--has-qr" : "message__container"}> 
                <div className={message.from !== 'user'? "message__text" : "message__text message__text--user"}>
                     {message.text}
                </div>
            </div>
        </div>
    )
}

export default Message
